import React, { Component } from "react";
import {
  Button,
  Form,
  Icon,
  Input,
  Col,
  Row,
  Select,
  Typography,
  message,
} from "antd";
import CircularProgress from "components/CircularProgress/index";
import code from "../../util/code.json";
import { createDataUnAuth } from "../../util/API";
import "./contact.less";
import _ from "lodash";

const FormItem = Form.Item;
const Option = Select.Option;
const { Text } = Typography;
const country_code = code.map((x) => (
  <Option key={x.name} name={x.code} value={x.dial_code}>
    {x.code}
  </Option>
));

class ContactDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      name: "",
      company_name: "",
      phone: "",
      country_code: "+91",
      uuid: localStorage.getItem("uuid") || "",
      cloader: false,
      loader: false,
      sendemail: false,
      sendmob: false,
      phone_code: "+91",
      otpVal: "",
      mobOtp: "",
      mob: "",
      verifyemail: false,
      verifymob: false,
      emailDisable: true,
      phoneDisable: true,
      verifyMobDisable: true,
      verifyEmailDisable: true,
      emailValue: "",
      emailTimer: "",
      phoneTimer: "",
      disableEmailResend: false,
      disablePhoneResend: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loader: true, cloader: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        this.setState({ cloader: false, loader: false });
        return;
      }

      const formData = new FormData();
      formData.append("company_name", values.companyName);
      formData.append("company_email", values.email);
      formData.append("company_phone", values.phone);
      formData.append("full_name", values.fullName);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("whatsapp_number", values.phone);
      formData.append("country_code", values.prefix);
      
      const endpoint = "/partner/temp-partner-add/";

      createDataUnAuth(endpoint, formData)
        .then((res) => {
          if (res.data["status"] === 200) {
            if (res.data["temp_vendor_id"]) {
              localStorage.setItem("temp_vendor_id", res.data["temp_vendor_id"]);
            }
            
            message.success(res.data["message"]);
            this.props.handleNext();
          } else {
            message.error(res.data["message"]);
          }
          this.setState({ cloader: false, loader: false });
        })
        .catch((error) => {
          console.log(error);
          message.error(error.toString());
          this.setState({ cloader: false, loader: false });
        });
    });
  };

  onChange = (e) => {
    this.setState({
      otpVal: parseInt(e.target.value),
      verifyEmailDisable: !e.target.value,
    });
  };

  onPhoneChange = (e) => {
    this.setState({
      mobOtp: parseInt(e.target.value),
      verifyMobDisable: !e.target.value,
    });
  };

  handleChange = (e) => {
    const input = e.target.value;
    const numericValue = input.replace(/\D/g, '');
    this.setState({
      mob: numericValue,
      phoneDisable: !numericValue,
    });
  };

  emailChange = (e) => {
    this.setState({
      emailValue: e.target.value,
      emailDisable: !e.target.value,
    });
  };

  selectCountryCode = (value) => {
    this.setState({ phone_code: value });
  };

  sendOTP = (otp_type) => {
    const endpoint = "/partner/send-otp/";
    let send_otp = {};
    if (otp_type === "email") {
      send_otp = { email: this.state.emailValue || this.state.email };
    } else {
      send_otp = {
        phone: this.state.phone_code + (this.state.mob || this.state.phone),
      };
    }

    createDataUnAuth(endpoint, send_otp)
      .then((res) => {
        if (res.status === 200) {
          this.setState(
            otp_type === "email"
              ? { sendemail: true, emailTimer: 60, disableEmailResend: true }
              : { sendmob: true, phoneTimer: 60, disablePhoneResend: true },
            () => {
              this.startTimer(otp_type);
            }
          );
          message.success("OTP sent successfully");
        } else {
          message.error("Error in sending OTP");
        }
      })
      .catch((error) => {
        console.log(error);
        message.error(error.response.data.message);
      });
  };

  startTimer = (otp_type) => {
    const timerKey = otp_type === "email" ? "emailTimer" : "phoneTimer";
    const disableKey =
      otp_type === "email" ? "disableEmailResend" : "disablePhoneResend";

    const interval = setInterval(() => {
      this.setState((prevState) => {
        const newTime = prevState[timerKey] - 1;
        if (newTime <= 0) {
          clearInterval(this[`${otp_type}Interval`]);
          return { [timerKey]: 0, [disableKey]: false };
        }
        return { [timerKey]: newTime };
      });
    }, 1000);

    this[`${otp_type}Interval`] = interval;
  };


  verifyOTP = (verify_type) => {
    let verify_otp = {};
    if (verify_type === "email") {
      verify_otp = {
        email: this.state.emailValue || this.state.email,
        otp: this.state.otpVal,
      };
    } else {
      verify_otp = {
        phone: this.state.phone_code + (this.state.mob || this.state.phone),
        otp: this.state.mobOtp,
      };
    }
    const endpoint = "/partner/verify-otp/";
    createDataUnAuth(endpoint, verify_otp)
      .then((res) => {
        if (res.data.status === 200) {
          message.success(res.data.message);
          this.setState(
            verify_type === "email"
              ? { verifyemail: true }
              : { verifymob: true }
          );
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        message.error(error.response.data.message);
      });
  };

  checkPhoneNumber = (rule, value, callback) => {
    if (this.state.phone_code !== "+91" || (value && value.length <= 10)) {
      callback();
      return;
    }
    callback(
      "Phone Number cannot exceed 10 digits for the selected country code!"
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { xs: { span: 12 }, sm: { span: 6 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
    };
    const tailBtnItemLayout = {
      wrapperCol: { xs: { span: 24, offset: 0 }, sm: { span: 24, offset: 0 } },
    };

    const prefixSelector = getFieldDecorator("prefix", {
      initialValue: this.state.country_code,
    })(
      <Select onSelect={this.selectCountryCode} style={{ width: 70 }}>
        {country_code}
      </Select>
    );

    return (
      <div>
        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: "4em" }}
          {...formItemLayout}
        >
          <FormItem label="Company Name">
            <Row gutter={[8, 16]}>
              <Col span={24}>
                <FormItem
                  name="companyName"
                  style={{ display: "inline-block", width: "100%" }}
                >
                  {getFieldDecorator("companyName", {
                    initialValue: this.state.company_name,
                    rules: [
                      {
                        required: true,
                        message: "Please enter your name!",
                        whitespace: true,
                      },
                    ],
                  })(<Input placeholder="Enter Company Name"/>)}
                </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="Full Name">
            <Row gutter={[8, 16]}>
              <Col span={24}>
                <FormItem
                  name="fullName"
                  style={{ display: "inline-block", width: "100%" }}
                >
                  {getFieldDecorator("fullName", {
                    initialValue: this.state.name,
                    rules: [
                      {
                        required: true,
                        message: "Please enter your name!",
                        whitespace: true,
                      },
                    ],
                  })(<Input placeholder="Enter Full Name"/>)}
                </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="E-mail" name="email1">
						<div className="gx-otp-fields">
							{getFieldDecorator("email", {
								initialValue: this.state.email,
								rules: [
									{
										type: "email",
										message: "The input is not a valid E-mail!",
									},
									{ required: true, message: "Please enter your E-mail!" },
								],
							})(
                <div className="gx-otp-input">
                  <Input
                    id="email1"
                    autoComplete="off"
                    value={this.state.emailValue}
                    onChange={this.emailChange}
                    placeholder="Enter Email Address"
                  />
                  {this.state.verifyemail ? (
                    <Text>Verified</Text>
                  ) : null}
                </div>
							)}
              <div className="gx-otp-inner">
                {this.state.verifyemail ? (
                  null
                ) : !this.state.sendemail ? (
                  <Button
                    type="primary"
                    block
                    onClick={() => this.sendOTP("email")}
                    disabled={this.state.emailDisable}
                    style={{ margin: 0 }}
                  >
                    Generate OTP
                  </Button>
                ) : (
                  <FormItem
                    name="email_otp"
                    style={{ display: "inline-block", width: "100%" }}
                  >
                    {getFieldDecorator("email_otp", {
                      initialValue: this.state.otpVal,
                      rules: [
                        { required: true, message: "Please enter the OTP!" },
                      ],
                    })(
                      <Input
                        id="otp"
                        value={this.state.otpVal || ""}
                        onChange={this.onChange}
                        placeholder="Enter OTP"
                      />
                    )}
                  </FormItem>
                )}
                {!this.state.verifyemail && this.state.sendemail && (
                  <Button
                    type="primary"
                    onClick={() => this.verifyOTP("email")}
                    disabled={this.state.verifyEmailDisable}
                    style={{ margin: 0 }}
                  >
                    Verify
                  </Button>
                )}
                {this.state.sendemail && !this.state.verifyemail && (
                  <Button
                    type="link"
                    htmlType="button"
                    onClick={() => this.sendOTP("email")}
                    //disabled={this.state.emailDisable}
                    disabled={this.state.disableEmailResend}
                    style={{ margin: 0 }}
                  >
                    {this.state.disableEmailResend
                      ? `Resend in ${this.state.emailTimer}s`
                      : "Resend OTP"}
                  </Button>
                )}
              </div>
						</div>
					</FormItem>
          <FormItem label="WhatsApp Number" name="phone">
						<div className="gx-otp-fields">
							{getFieldDecorator("phone", {
                initialValue: this.state.phone,
                validateTrigger: "onChange",
                rules: [
                  {
                    required: true,
                    message: "Please enter your phone number!",
                  },
                  { validator: this.checkPhoneNumber },
                ],
              })(
                <div className="gx-otp-input">
                  <Input
                    addonBefore={prefixSelector}
                    value={this.state.mob || ""}
                    onChange={this.handleChange}
                    placeholder="Enter WhatsApp Number"
                    maxLength={10}
                    minLength={10}
                  />
                  {this.state.verifymob ? (
                    <Text>Verified</Text>
                  ) : null}
                </div>
              )}
              <div className="gx-otp-inner">
                {this.state.verifymob ? (
                  null
                ) : !this.state.sendmob ? (
                  <Button
                    type="primary"
                    block
                    onClick={() => this.sendOTP("phone")}
                    disabled={this.state.phoneDisable}
                    style={{ margin: 0 }}
                  >
                    Generate OTP
                  </Button>
                ) : (
                  !this.state.verifymob && (
                    <FormItem
                      name="phone_otp"
                      style={{ display: "inline-block", width: "80%" }}
                    >
                      {getFieldDecorator("phone_otp", {
                        initialValue: this.state.mobOtp,
                        rules: [
                          { required: true, message: "Please enter the OTP!" },
                        ],
                      })(
                        <Input
                          id="otp"
                          placeholder="Enter OTP"
                          value={this.state.mobOtp || ""}
                          onChange={this.onPhoneChange}
                        />
                      )}
                    </FormItem>
                  )
                )}
              {!this.state.verifymob && this.state.sendmob && (
                <Button
                  type="primary"
                  onClick={() => this.verifyOTP("phone")}
                  disabled={this.state.verifyMobDisable}
                  style={{ margin: 0 }}
                >
                  Verify
                </Button>
              )}
              {this.state.sendmob && !this.state.verifymob && (
                <Button
                  type="link"
                  htmlType="button"
                  onClick={() => this.sendOTP("phone")}
                  //disabled={this.state.phoneDisable}
                  disabled={this.state.disablePhoneResend}
                  style={{ margin: 0 }}
                >
                  {this.state.disablePhoneResend
                    ? `Resend in ${this.state.phoneTimer}s`
                    : "Resend OTP"}
                </Button>
              )}
              </div>
						</div>
					</FormItem>
          
          <FormItem style={{ marginTop: "3em" }} {...tailBtnItemLayout}>
            <Button
              style={{ float: "right" }}
              type="primary"
              htmlType="submit"
              icon="arrow-right"
              loading={this.state.loader}
              disabled={!this.state.verifyemail || !this.state.verifymob}
            >
              Register & Continue
            </Button>
          </FormItem>
        </Form>
        {this.state.cloader && (
          <div className="gx-loader-view gx-loader-position">
            <CircularProgress />
          </div>
        )}
      </div>
    );
  }
}

const ContactDetailsForm = Form.create()(ContactDetails);
export default ContactDetailsForm;
